import { render, staticRenderFns } from "./PartsOrdered.vue?vue&type=template&id=74e6d77a&scoped=true"
import script from "./PartsOrdered.vue?vue&type=script&lang=js"
export * from "./PartsOrdered.vue?vue&type=script&lang=js"
import style0 from "./PartsOrdered.vue?vue&type=style&index=0&id=74e6d77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6d77a",
  null
  
)

export default component.exports